module.exports = __webpack_public_path__ + "static/media/left-move.88240319.svg";